export default "<app-imagetext [prodId]=\"'insurance'\"></app-imagetext>\n<app-product3 [prodId]=\"'insurance'\"></app-product3>\n<app-footer></app-footer>"